import { createStore } from "vuex";
import Home from "/src/store/modules/home/index.js";
import About from "/src/store/modules/about/index.js";
import Archive from "/src/store/modules/archive/index.js";
import Works from "/src/store/modules/works/index.js";
import Legacy from "/src/store/modules/legacy/index.js";
import Collections from "/src/store/modules/collections/index.js";
import Contact from "/src/store/modules/contact/index.js";
export default createStore({
  modules: {
    home: Home,
    about: About,
    archive: Archive,
    works: Works,
    legacy: Legacy,
    collections: Collections,
    contact: Contact,
  },
  state: {
    isLoading: true,
  },
  mutations: {
    setLoading(state, payload) {
      state.isLoading = payload;
    },
  },
  actions: {
    async getAll(context, payload) {
      let RoutesAndActions = {
        Home: "home/home",
        Biography: "about/biography",
        personalPhotos: "about/personalPhotos",
        ContactUs: "contact/contacts",
      };

      if (RoutesAndActions[payload] != undefined) {
        await context.dispatch(RoutesAndActions[payload]);
      }
      delete RoutesAndActions[payload];
      await context.commit("setLoading", false);
      for (let route in RoutesAndActions) {
        await context.dispatch(RoutesAndActions[route]);
      }
    },
  },
  getters: {
    isLoading(state) {
      return state.isLoading;
    },
  },
});
